import { SITE_NAME } from "../lib/constants.js";

// Final part of each meta title sitewise
export const META_TITLE_END = ` - ${SITE_NAME}`;

// Index page
export const META_MAIN_TITLE = `${SITE_NAME} - Discover Movies and TV Shows`;
export const META_MAIN_DESC = `${SITE_NAME} is your ultimate platform for exploring movies and TV shows. Discover detailed information, search for your favorites, and enjoy personalized recommendations`;
export const META_MAIN_KEYW = `movies, tv shows, entertainment, streaming, genres, recommendations, ${SITE_NAME}, film, series, movie database`;

// Main pages
export const META_MAIN_MOVIES_TITLE = `Explore Movies${META_TITLE_END}`;
export const META_MAIN_MOVIES_DESC = `Browse through a variety of movies on ${SITE_NAME}, discover trending films, and find top-rated movies on our platform`;
export const META_MAIN_MOVIES_KEYW = `movies, films, trending movies, top-rated movies, action movies, drama movies`;

export const META_MAIN_SHOWS_TITLE = `Discover Shows${META_TITLE_END}`;
export const META_MAIN_SHOWS_DESC = `Find your favorite TV shows on ${SITE_NAME}, discover new series, and check out the latest trending and top-rated shows`;
export const META_MAIN_SHOWS_KEYW = `tv shows, series, trending shows, top-rated shows, drama series, comedy series`; 

export const META_MOVIES_GENRE_TITLE = ` Genre - Movies list${META_TITLE_END}`;
export const META_MOVIES_GENRE_DESC = `Explore a wide selection of movies from different genres. Find top-rated, trending, and classic films all in one place`;

export const META_SHOWS_GENRE_TITLE = ` Genre - Shows list${META_TITLE_END}`;
export const META_SHOWS_GENRE_DESC = `Browse through a collection of shows spanning multiple genres. From popular hits to hidden gems, find your next favorite series here`;

// Other pages
export const META_SITEMAP_TITLE = `Site Map${META_TITLE_END}`;
export const META_SITEMAP_DESC = `Explore the comprehensive sitemap of ${SITE_NAME}, where you can find links to all key sections, including movies, shows, actors, and more. Easily navigate through the platform and discover all available content and future features`;

export const META_SEARCH_TITLE = `search results${META_TITLE_END}`;
export const META_SEARCH_DESC = `Browse search results on ${SITE_NAME}. Discover movies, TV shows, and actors that match your search, with detailed info, ratings, and more`;

export const META_ABOUT_US_TITLE = `About Us${META_TITLE_END}`;
export const META_ABOUT_US_DESC = `Learn more about ${SITE_NAME}, our mission, and the features that make it a unique platform for discovering movies, shows, and actors. Get insights into the technology and vision behind ${SITE_NAME}`;

export const META_APP_INFO_TITLE = `App Info${META_TITLE_END}`;
export const META_APP_INFO_DESC = `Learn more about ${SITE_NAME}, our mission, and the features that make it a unique platform for discovering movies, shows, and actors. Get insights into the technology and vision behind ${SITE_NAME}`;

export const META_CONTACT_TITLE = `Contact Us${META_TITLE_END}`;
export const META_CONTACT_DESC = `Get in touch with us at ${SITE_NAME}! Whether you have questions, feedback, or suggestions, we're here to hear from you`;

export const META_PRIVACY_TITLE = `Privacy Policy${META_TITLE_END}`;
export const META_PRIVACY_DESC = `At ${SITE_NAME}, your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our platform`;

export const META_TERMS_TITLE = `Terms of Use${META_TITLE_END}`;
export const META_TERMS_DESC = `Your ultimate platform for exploring movies and TV shows. By using ${SITE_NAME}, you agree to abide by the following terms and conditions. Please review them carefully before using the site`;

export const META_ERROR_FORM_TITLE = `Form Error${META_TITLE_END}`;
export const META_ERROR_FORM_DESC = `Something went wrong while submitting your message. Please try again or contact us through other means. We apologize for the inconvenience`;

export const META_SUCCESS_FORM_TITLE = `Form Success${META_TITLE_END}`;
export const META_SUCCESS_FORM_DESC = `Your message has been successfully sent! We'll get back to you as soon as possible. Thank you for reaching out to ${SITE_NAME}!`;

export const META_NOT_FOUND_TITLE = `Page Not Found${META_TITLE_END}`;
export const META_NOT_FOUND_DESC = `The page you're looking for doesn't exist. Please check the URL or return to the homepage`;

export const META_ERROR_TITLE = `Error${META_TITLE_END}`;
export const META_ERROR_DESC = `An unexpected error has occurred. Please try again later or return to the homepage for more options`;
